import * as React from "react";

function SvgAddTopics(props) {
  return <svg width={41} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={41} height={22} rx={11} fill="#2A678C" /><path d="M25.25 13.688v1.562h1.563l4.608-4.608-1.563-1.563-4.608 4.609zm7.38-4.255a.415.415 0 000-.587l-.976-.975a.415.415 0 00-.587 0l-.763.762 1.563 1.563.762-.763zM13.681 16.302l.95.9a.5.5 0 00.844-.364v-3.462a.5.5 0 01.103-.305l4.805-6.267A.5.5 0 0019.987 6H9.013a.5.5 0 00-.396.804l4.805 6.267a.5.5 0 01.103.305v2.563a.5.5 0 00.156.363z" fill="#fff" /></svg>;
}

export default SvgAddTopics;